/**
 * Language features
 * @module services/languages
 */
import { OrderedSet, Map } from 'immutable'
import {
  LANGUAGE_EN,
  LANGUAGE_ES,
  LANGUAGE_DE,
  LANGUAGE_FR,
  FILE_LANGUAGE_DE,
  FILE_LANGUAGE_EN,
  FILE_LANGUAGE_ES,
  FILE_LANGUAGE_FR,
} from './constants'

/**
 * A list of supported content languages with labels
 */
const LANUGUAGE_OPTIONS = OrderedSet([
  Map({ label: 'English', value: LANGUAGE_EN }),
  Map({ label: 'French', value: LANGUAGE_FR }),
  Map({ label: 'German', value: LANGUAGE_DE }),
  Map({ label: 'Spanish', value: LANGUAGE_ES }),
])

export const FILE_LANGUAGES_MAP = {
  [FILE_LANGUAGE_EN]: LANGUAGE_EN,
  [FILE_LANGUAGE_FR]: LANGUAGE_FR,
  [FILE_LANGUAGE_DE]: LANGUAGE_DE,
  [FILE_LANGUAGE_ES]: LANGUAGE_ES,
}

/**
 * Get a list of all supported languages
 * @param {Set|List} [languages] A list or set of optional languages
 * when provided only return the languages in the list
 * @returns {OrderedSet} A Set of language Maps with a label and value property
 */
export function getLanguageOptionsSupported () {
  return LANUGUAGE_OPTIONS
}

/**
 * Given a language code the the label text
 * @param {String} language The language code
 * @returns {String} The language label text
 */
export function getLanguageLabel (language) {
  const languageData = LANUGUAGE_OPTIONS.find((v) => v.get('value') === language) || Map()
  return languageData.get('label') || ''
}

/**
 * Gets the CSS class name for a language chip
 * @param {string} languageCode - The language code (e.g., 'en', 'es', 'fr', 'de')
 * @returns {string} The CSS class name for the language
 */
export function getLanguageChipClass (languageCode) {
  const languageClassMap = {
    en: 'language-chip--english',
    es: 'language-chip--spanish',
    fr: 'language-chip--french',
    de: 'language-chip--german',
  }
  return languageClassMap[languageCode] || 'language-chip--default'
}
